import { type StoreName } from '~/types/Store';

export enum OnboardingRoute {
  connectStore = '/onboarding/connect_store',
  plan = '/onboarding/plan',
  senderAddress = '/onboarding/sender_address',
}

export enum OnboardingPlan {
  API = 'API',
  PRO = 'PRO',
  STARTER = 'PAYG-Standard',
}

export enum OnboardingExit {
  ADDRESS = 'Address',
  API = 'API',
  CSV = 'CSV',
  MANUAL = 'Manual',
  ORDERS = 'orders',
  STORE = 'Store',
}

type PaygFormat = `PAYG ${string} ${string} ${string}`;
type ProFormat = `Pro ${string}`;
type ApiFormat = 'API';
export type PlanCode = ApiFormat | PaygFormat | ProFormat;

export type Plan = {
  description: string;
  featureCaption?: string;
  features: string[];
  icon: string;
  id: OnboardingPlan;
  planCode: PlanCode;
  pricing: string;
  title: string;
};

export enum OnboardingStepName {
  addOrders = 'onboarding.AddOrders',
  connectStore = 'onboarding.ConnectStore',
  plan = 'onboarding.ChoosePlan',
  senderAddress = 'onboarding.AddSenderAddress',
}

export type StoreConnectionStartedType = 'API' | 'CSV Upload' | 'Manual Order' | StoreName;

export type OnboardingStepCompleted = {
  current_step_index?: number;
  current_step_name?: string;
  last_completed_step_index?: null | number;
  last_completed_step_name?: null | string;
  store_connection_started?: StoreConnectionStartedType;
};

export type OnboardingHeaderProps = {
  steps?: {
    current: number;
    total: number;
  };
  title: string;
};

export type OnboardingStepAction =
  | {
      payload: { exit: OnboardingExit; store: StoreConnectionStartedType };
      type: 'exit';
    }
  | { payload: OnboardingStepName; type: 'step' }
  | { payload: StoreConnectionStartedType; type: 'store' };

export type CurrentOnboardingStep = {
  exit?: OnboardingExit;
  name: OnboardingStepName;
  store?: StoreConnectionStartedType;
};

export enum OnboardingLocalStorageKeys {
  ONBOARDING_BUSINESS_TYPE = 'shippo_onboarding_business_type',
  ONBOARDING_CURRENT_STEP = 'onboarding_current_step',
  ONBOARDING_IN_PROGRESS = 'onboarding_in_progress',
  ONBOARDING_LAST_STEP = 'onboarding_last_step',
  ONBOARDING_SELECTED_PLAN = 'onboarding_selected_plan',
  SHOULD_ONBOARD = 'shippo_should_onboard',
}
